module.exports = __webpack_public_path__ + "media/images/Video-f83f99c0.png";